import dayjs from "dayjs";
import { OrderTimeSlot } from "@/types";

/** Key used to match an order to the reception slot it was booked into (date + slot start time). */
export function orderSlotKey(dateIso: string, startTime: string): string {
  return `${dateIso}_${startTime}`;
}

/** Groups orders by calendar date (YYYY-MM-DD), for the month view. */
export function groupOrdersByDate(orders: OrderTimeSlot[]): Map<string, OrderTimeSlot[]> {
  const map = new Map<string, OrderTimeSlot[]>();
  for (const order of orders) {
    if (!order.startDate) continue;
    const key = dayjs(order.startDate).format("YYYY-MM-DD");
    const existing = map.get(key);
    if (existing) existing.push(order);
    else map.set(key, [order]);
  }
  return map;
}

/** Groups orders by the reception slot (date + start time) they were booked into, for the week view. */
export function groupOrdersBySlotKey(orders: OrderTimeSlot[]): Map<string, OrderTimeSlot[]> {
  const map = new Map<string, OrderTimeSlot[]>();
  for (const order of orders) {
    if (!order.startDate) continue;
    const key = orderSlotKey(dayjs(order.startDate).format("YYYY-MM-DD"), dayjs(order.startDate).format("HH:mm:ss"));
    const existing = map.get(key);
    if (existing) existing.push(order);
    else map.set(key, [order]);
  }
  return map;
}
